import { EditOutlined } from "@ant-design/icons";
import { Button, Col, Row, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";

const { Text } = Typography;

const CollapseSectionHeader = ({
  name,
  route,
  parent = "applications",
  id = null,
}) => {
  const navigate = useNavigate();
  const { applicationId } = useParams();

  return (
    <Row align="middle" justify="space-between" style={{ width: "100%" }}>
      <Col>
        <Text strong>{name}</Text>
      </Col>
      <Col>
        <Button
          size="small"
          icon={<EditOutlined />}
          onClick={() =>
            navigate(`/${parent}/edit/${id ?? applicationId}/${route}`)
          }
        >
          Edit
        </Button>
      </Col>
    </Row>
  );
};

export default CollapseSectionHeader;
